<script setup>
import { legalFeatures } from '~/assets/jsons/contents/pages/profession/country.json';
import { originalCountries } from '~/assets/jsons/originalParams.json';

const route = useRoute();
const { country } = route.params;
const originalCountry = originalCountries[country];

</script>

<template>
    <section class="py-16 md:py-24 bg-[var(--p-background-ground)]">
      <div class="container mx-auto px-4">
        <h2
        data-aos="fade-up"
        class="text-3xl font-bold text-center mb-12 text-[var(--p-primary-800)]">{{ $t(`lawyerCountries.${originalCountry}.howOurAIAssists`) }}</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div 
          data-aos="fade-up"
            v-for="(feature, index) in legalFeatures" 
            :key="index" 
            class="bg-[var(--p-background-card)] rounded-lg p-6 m-4 shadow-lg hover:shadow-xl transition-shadow"
          >
            <div
            data-aos="fade-up"
            class="w-16 h-16 bg-[var(--p-primary-100)] rounded-full flex items-center justify-center mb-4 mx-auto">
              <i :class="`${feature.icon} text-[var(--p-primary-600)]`" style="font-size: 1.5rem;"></i>
            </div>
            <h3
            data-aos="fade-up"
            class="text-xl font-semibold text-center mb-4 text-[var(--p-primary-800)]">{{ $t(`pages.profession.legalFeatures.${feature.title}`) }}</h3>
            <p
            data-aos="fade-up"
            class="text-[var(--p-text-secondary-color)] text-center">
              {{ $t(`pages.profession.legalFeatures.${feature.description}`) }}
            </p>
          </div>
        </div>
      </div>
    </section>
</template>
